import { render, staticRenderFns } from "./SadFaceComponent.vue?vue&type=template&id=f1d9f616&scoped=true&"
import script from "./SadFaceComponent.vue?vue&type=script&lang=js&"
export * from "./SadFaceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SadFaceComponent.vue?vue&type=style&index=0&id=f1d9f616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d9f616",
  null
  
)

export default component.exports